import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import CancelPage from './components/CancelPage';
import SuccessPage from './components/SuccessPage';
import BloggenPage from './BloggenPage'; 
import logo from './assets/bloglogo.png';

function App() {
  const { 
    isAuthenticated,
    user,
    loginWithRedirect,
    logout,
    isLoading,
    getAccessTokenSilently
  } = useAuth0();

  if (isLoading) {
    // A simple loading state
    return <div style={{ textAlign: 'center', marginTop: '20%', fontSize: '1.5rem' }}>Loading...</div>;
  }

  return (
    <BrowserRouter>
      <div className="App">
        {/* Logo is now placed outside the header for cleaner structure */}
        <img src={logo} alt="Bloggen Logo" className="app-logo" />

        <header className="App-header">
          {/* Title is now in its own element for better styling control */}
          <h1 className="header-title">Blog-Gen ✓</h1>
          
          <div className="auth-container">
            {
              !isAuthenticated ? (
                <button className="button-login" onClick={() => loginWithRedirect()}>
                  Log In
                </button>
              ) : (
                <>
                <p>Hello, {user?.given_name}</p>
                {/* {user?.picture && (
                  <img 
                    src={user.picture} 
                    alt={user.name || 'User profile'} 
                  />
                )} */}
                  <button 
                    className="button-logout"
                    onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
                  >
                    Log Out
                  </button>
                </>
              )
            }
          </div>
        </header>

        <main>
          <Routes>
            <Route path="/success" element={<SuccessPage />} />
            <Route path="/cancel" element={<CancelPage />} />
            <Route path="/" element={
              isAuthenticated ? (
                <BloggenPage getAccessTokenSilently={getAccessTokenSilently} />
              ) : (
                <div className="login-prompt">
                  <h2>Please log in to create your content.</h2>
                </div>
              )
            } />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}

export default App;